<template>
  <div
    v-if="zoneGroups.length"
    ref="scroller"
    class="covering-image-strip d-flex align-center"
    @wheel="onWheel"
  >
    <template v-for="(group, groupIndex) in zoneGroups">
      <v-divider
        v-if="groupIndex > 0"
        :key="`rule-${group.zone}`"
        vertical
        class="mx-2 covering-image-strip__rule"
      />
      <div :key="group.zone" class="d-flex align-center">
        <CoveringZoneBadge :zone="group.zone" class="mr-1" />
        <v-tooltip
          v-for="row in group.items"
          :key="row.image.id || row.index"
          bottom
          max-width="200"
        >
          <template slot="activator" slot-scope="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              text
              small
              class="text-none text-body-2 covering-image-strip__file px-2"
              :class="fileBtnClass(row.index)"
              :data-covering-nav="row.index"
              @click="$emit('select', row.index)"
            >
              {{ fileLabel(row) }}
            </v-btn>
          </template>
          <div>
            <div class="text-caption mb-1">{{ fileLabel(row) }}</div>
            <v-img
              v-if="row.image.thumbImgUrl"
              :src="row.image.thumbImgUrl"
              width="160"
              height="120"
              contain
            />
          </div>
        </v-tooltip>
      </div>
    </template>
  </div>
</template>

<script>
  import { groupCoveringImagesByFrameZone } from '@/features/defect-drawer/utils/resolveModuleCoveringIrImages';
  import CoveringZoneBadge from '@/features/defect/components/CoveringZoneBadge.vue';

  export default {
    name: 'DefectCoveringImageStrip',
    components: { CoveringZoneBadge },
    props: {
      items: { type: Array, default: () => [] },
      selectedIndex: { type: Number, default: 0 }
    },
    computed: {
      zoneGroups() {
        return groupCoveringImagesByFrameZone(this.items, 'all');
      }
    },
    watch: {
      selectedIndex() {
        this.$nextTick(this.scrollSelectedIntoView);
      }
    },
    mounted() {
      this.scrollSelectedIntoView();
    },
    methods: {
      fileLabel(row) {
        return row.image?.imgName || row.image?.id || String(row.index + 1);
      },
      fileBtnClass(index) {
        return index === this.selectedIndex
          ? 'primary--text font-weight-bold covering-image-strip__file--selected'
          : 'text--secondary';
      },
      onWheel(event) {
        const el = this.$refs.scroller;
        if (!el || el.scrollWidth <= el.clientWidth) {
          return;
        }
        const dx = event.deltaX !== 0 ? event.deltaX : event.deltaY;
        if (!dx) {
          return;
        }
        event.preventDefault();
        el.scrollLeft += dx;
      },
      scrollSelectedIntoView() {
        const root = this.$refs.scroller;
        const el = root?.querySelector(`[data-covering-nav="${this.selectedIndex}"]`);
        if (!root || !el) {
          return;
        }
        const rootRect = root.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();
        if (elRect.left < rootRect.left) {
          root.scrollLeft -= rootRect.left - elRect.left;
        } else if (elRect.right > rootRect.right) {
          root.scrollLeft += elRect.right - rootRect.right;
        }
      }
    }
  };
</script>

<style scoped>
  .covering-image-strip {
    width: 100%;
    min-width: 0;
    overflow-x: auto;
    overflow-y: hidden;
    flex-wrap: nowrap;
  }

  .covering-image-strip__rule {
    height: 16px;
    align-self: center;
  }

  .covering-image-strip__file {
    min-width: 0 !important;
    max-width: 11rem;
    height: 32px !important;
    font-size: 0.875rem !important;
    letter-spacing: 0;
  }

  .covering-image-strip__file >>> .v-btn__content {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .covering-image-strip__file--selected {
    border-radius: 0;
    box-shadow: inset 0 -2px 0 currentColor;
  }
</style>
